import { FC, useState, ChangeEvent } from 'react';
import cx from 'classnames/bind';

import { Checkbox } from '@/components/Checkbox';
import { Switch } from '@/components/Switch';
import type { ICapsules, IPeculiarities } from '@/types/pack';

import styles from './MultipleQuestion.module.scss';

const cn = cx.bind(styles);

interface QuestionProps {
  title: string;
  answers: ICapsules[] | IPeculiarities[];
  handleClick?: () => void;
  changeCheckboxValue: (e: ChangeEvent<HTMLInputElement>, id: number) => void;
  isDisabled?: (id: number) => boolean;
  resetCheckboxes: () => void;
  cursor?: string;
  setCursor?: (value: string) => void;
  firstPlay?: boolean;
}

const MultipleQuestion: FC<QuestionProps> = ({
  title,
  answers,
  handleClick,
  changeCheckboxValue,
  isDisabled,
  resetCheckboxes,
  cursor,
  setCursor,
  firstPlay,
}) => {
  const [isShowCheckboxes, setIsShowCheckboxes] = useState(false);

  return (
    <div className={cn('container')}>
      <div className={cn('header')}>
        <div className={cn('title')}>{title}</div>
        <Switch
          setIsShowCheckboxes={setIsShowCheckboxes}
          handleClick={handleClick}
          resetCheckboxes={resetCheckboxes}
          cursor={cursor}
          setCursor={setCursor}
          firstPlay={firstPlay}
        />
      </div>
      {isShowCheckboxes && (
        <div className={cn('wrapper')}>
          {answers.map(({ text, id }) => (
            <Checkbox
              key={id}
              id={id}
              text={text}
              changeCheckboxValue={changeCheckboxValue}
              isDisabled={isDisabled}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MultipleQuestion;
